import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(value, currency = "USD") {
  return new Intl.NumberFormat('es-UY', {
    style: 'currency',
    currency: currency === "USD" ? "USD" : "UYU",
    minimumFractionDigits: 2
  }).format(value);
}

export function formatDate(date) {
  if (!date) return "";
  const d = typeof date === 'string' ? new Date(date) : date;
  return d.toLocaleDateString('es-UY', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  });
}

export function formatNumber(value) {
  return new Intl.NumberFormat('es-UY').format(value);
}
